import React, { useState } from 'react';
import { motion } from 'framer-motion';

interface AnimatedCloseButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  animationDuration?: number;
}

export default function AnimatedCloseButton({ 
  onClick, 
  disabled = false, 
  className = '',
  size = 'md',
  animationDuration = 200 
}: AnimatedCloseButtonProps) {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleClick = () => {
    if (isAnimating || disabled) return;
    
    setIsAnimating(true);
    // Animasyon tamamlandıktan sonra onClick'i çağır
    setTimeout(() => {
      setIsAnimating(false);
      onClick();
    }, animationDuration);
  };

  // Size variants
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  const iconSize = sizeClasses[size];

  return (
    <motion.button
      onClick={handleClick}
      className={`text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors ${className}`}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9, rotate: 90 }}
      transition={{ type: "spring", stiffness: 400, damping: 17 }}
      disabled={isAnimating || disabled}
      aria-label="Kapat"
    >
      <svg className={iconSize} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </motion.button>
  );
}
